
    import {Component, Prop, Vue} from "vue-property-decorator";

    @Component
    export default class CategoryCard extends Vue {
        @Prop() readonly category!: string;
        @Prop() readonly img!: string;
    }
